import { axiosWithToken } from '../utils/functions/apiCallWithToken';
import { SERVER_URL as serverURL } from '../core/config';


export const createNotification = async (data) => {
    const result = await axiosWithToken(`${serverURL}/notification/create/`, 'post', data);
    return result;
}

export const clearNotifications = async () => {
    const result = await axiosWithToken(`${serverURL}/notification/clear/`, 'post', {});
    return result;
}

export const fetchNotifications = async () => {
    const result = await axiosWithToken(`${serverURL}/notification/`, 'get', {});
    return result;
}

export const markNotificationRead = async (id) => {
    const result = await axiosWithToken(`${serverURL}/notification/read/${id}`, 'post', {});
    return result;
}